import { Component, OnInit } from '@angular/core';
import { ToasterService, ConfirmationService, Confirmation } from '@abp/ng.theme.shared';
import { EXTENSIONS_IDENTIFIER } from '@abp/ng.theme.shared/extensions';
import { ListService } from '@abp/ng.core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { Store, Select } from '@ngxs/store';
import { Observable, interval } from 'rxjs';
import { eTerminalManagementComponents } from '../../enums';
import { TerminalLogState } from '../../states/terminal-log.state';
import { TerminalLog } from '../../models';
import { GetTerminalLogs, DeleteTerminalLog } from '../../actions/terminal-log.actions';

@Component({
	selector: 'lib-terminal-log',
	templateUrl: './terminal-log.component.html',
	styleUrls: ['./terminal-log.component.less'],
	providers: [
		ListService,
		{
			provide: EXTENSIONS_IDENTIFIER,
			useValue: eTerminalManagementComponents.TerminalLogs,
		},
	]
})
export class TerminalLogComponent implements OnInit {

	@Select(TerminalLogState.logs)
	logs$: Observable<TerminalLog.TerminalLogItem[]>;

	@Select(TerminalLogState.logTotalcount)
	logsTotalcount$: Observable<number>;

	isModalVisible: boolean = false;
	selected: TerminalLog.TerminalLogItem;

	pageQuery = {
		skipCount: 0,
		maxResultCount: 10
	} as TerminalLog.TerminalLogListRequest;

	constructor(
		public readonly list: ListService,
		private toasterService: ToasterService,
		private confirmationService: ConfirmationService,
		private store: Store
	) { }

	ngOnInit(): void {
		this.hookToQuery();
	}

	private hookToQuery() {

		this.list.hookToQuery(query => {
			let q = {
				...this.pageQuery,
				...query
			} as TerminalLog.TerminalLogListRequest;

			return this.store.dispatch(new GetTerminalLogs(q))
		}).subscribe();

	}

	delete(id: string) {
		this.confirmationService.warn('TerminalManagement::TerminalLogDeletionConfirmationMessage', 'AbpIdentity::AreYouSure').subscribe(
			(status: Confirmation.Status) => {
				if (status === Confirmation.Status.confirm) {
					this.store.dispatch(new DeleteTerminalLog(id))
						.subscribe(() => {
							this.list.get();
						});
				}
			}
		)
	}

	lookup(item: TerminalLog.TerminalLogItem) {
		this.selected = { ...item };
		this.isModalVisible = true;
	}
}
